import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

async function getGeoLocation() {
  if (navigator && navigator.geolocation) {
    return new Promise((done) => {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          done(pos.coords);
        },
        (error) => {
          console.warn("getLocation", error);
            // switch(error.code) {
            //   case error.PERMISSION_DENIED:
            //     alert("User denied the request for Geolocation.")
            //     break;
            //   case error.POSITION_UNAVAILABLE:
            //     alert("Location information is unavailable.")
            //     break;
            //   case error.TIMEOUT:
            //     alert("The request to get user location timed out.")
            //     break;
            //   case error.UNKNOWN_ERROR:
            //     alert("An unknown error occurred.")
            //     break;
            // }
          done(null);
        }
      );
    });
  }
  return null;
}

export default new Vuex.Store({
  state: {
    categories: {
      error: null,
      loading: false,
      loaded: false,
      data: [],
    },
    providerFilters: {
      searchText: "",
      categoryIds: [],
      location: {
        latitude: 0,
        longitude: 0,
      },
      limit: 15
    },
    serviceId: null
  },
  mutations: {
    categories(state, { error, loading, loaded, data }) {
      state.categories = { error, loading, loaded, data };
    },
    providerFilters(state, { searchText, categoryIds, location }) {
      state.providerFilters.searchText =
        searchText != null ? searchText : state.providerFilters.searchText;
      state.providerFilters.categoryIds =
        categoryIds || state.providerFilters.categoryIds;

      if (location && location.latitude && location.longitude) {
        state.providerFilters.location.latitude = location.latitude;
        state.providerFilters.location.longitude = location.longitude;
      }
    },
    changeParameterSeviceId(state, serviceId) {
        state.serviceId = serviceId;
    }
  },
  actions: {
    async saveParameterSeviceId({ commit }, serviceId){
        commit("changeParameterSeviceId", serviceId);
    },
    async loadLocation({ commit }) {
      const location = await getGeoLocation();
      console.log("location", location);
      if (location) {
        commit("providerFilters", {
          location
        });
        return;
      }
      commit("providerFilters", {
        location: { latitude: 0, longitude: 0 },
      });
    },
    loadCategories({ state, commit }) {
      if (
        state.categories.loaded ||
        state.categories.loading ||
        state.categories.error
      ) {
        return;
      }
      const languageStore = (localStorage && localStorage.language) || 'en';
      console.log("language", languageStore);
      commit("categories", { ...state.categories, loading: true });
      this.$oddjob.settings
        .getCategories({ statuses: "active", language: languageStore })
        .then((res) => {
          commit("categories", {
            error: null,
            loading: false,
            loaded: true,
            data: res.data.results.map(category => {
              category.logo = category.logo.replace('small','origin');
               return category;
            }),
          });
          if(!state.serviceId){
            commit("providerFilters", { categoryIds: [res.data.results[0]._id] });        
          }else{
            commit("providerFilters", { categoryIds: [state.serviceId] });  
          }
        })
        .catch((err) => {
          commit("categories", {
            error: err,
            loading: false,
            loaded: true,
            data: [],
          });
        });
    },
  },
  modules: {},
});
